export default "__VITE_ASSET__6TMh3Tx3__"